





































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
//import App from "@/components/Global/GetAppData"; //缓存接口
import Enum from "@/components/Global/enumerate"; //全局常量
import utils from "@/store/utils"; //工具类
import { WxImg } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
@Component({
  components: {}
})
export default class extends Vue {
  $message: any;
  //注入数据 @Provide()
  @Prop()
  private AddaccountForm: WxImg | any; //定义数据在WxImg里
  private FileBase64: any;
  //浏览图片相关
  private viewImage = false;
  //功能库相关
  private libraryview = false;
  private LibraryTabData = [];
  private templateSelection: any;
  private search: string = "";
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private totalItem: number = 0;
  private inboxTabData: any = [];
  private Nature: string = "1";
  private tableName: string = "AppReplyGraphic";
  private Naturedisabled = false;
  private GetAppData: any = []; //取应用号信息
  private switchType = false;
  private switchNature = true;
  private switchState = true;
  //查看图片
  private picture = {
    url: "",
    height: ""
  };
  @Provide()
  //验证数据
  data() {
    //验证网址
    let isValidateURL = (
      rule: any,
      value: string,
      callback: { (arg0: Error): void; (): void }
    ) => {
      if (!utils.validateURL(value)) {
        return callback(new Error("请输入正确的网址"));
      } else {
        callback();
      }
    };

    //验证必填字段
    return {
      rules: {
        Keyword: [
          { required: true, message: "请输入关键词", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        Type: [
          { required: true, message: "请选择消息类型", trigger: "change" }
        ],
        State: [
          { required: true, message: "请选择状态类型", trigger: "change" }
        ],
        Nature: [
          { required: true, message: "请选择素材类型", trigger: "change" }
        ],
        UploadImage: [
          {
            required: true,
            message: "请输入图片地址或上传图片",
            trigger: "blur"
          }
          // { validator: isValidateURL }
        ]
      }
    };
  }
  //取消方法
  cancle() {
    this.$emit("refresh");
  }
  //功能库
  async library() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      // if (this.tableName == "AppReplyGraphic") {
      //   this.Naturedisabled = true;
      //   this.Nature = "1";
      // } else {
      //   this.Naturedisabled = false;
      // }
      let params: any = {
        Input: [
          { Name: "aid", value: AppAccount.Aid },
          { Name: "TableName", value: this.tableName },
          { Name: "Nature", value: this.Nature },
          { Name: "State", value: "1" }
        ]
      };
      // console.log(params);
      var res: any = await httpApi.KeyAll(params);
      if (res.ErrorCode == 0) {
        this.LibraryTabData = res.output[0].value;
        const search = this.search;
        if (search) {
          console.log(search);
          this.LibraryTabData = res.output[0].value.filter(
            (x: {
              Keyword: {
                toUpperCase: () => { indexOf: (arg0: string) => number };
              };
            }) =>
              x.Keyword.toUpperCase().indexOf(search.trim().toUpperCase()) != -1
          );
        }
        //this.totalItem = this.LibraryTabData.length;
        this.loadData();
      } else {
        this.$message.error(res.ErrorMessage);
      }
      // console.log(res);
    }
    this.libraryview = true;
  }
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.library();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.library();
  }
  //分页方法数据
  loadData() {
    if (this.LibraryTabData) {
      this.inboxTabData = this.LibraryTabData.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
      this.totalItem = this.LibraryTabData.length;
    }
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.UpdaterDate != null && row.UpdaterDate != "") {
      // var date = new Date(row.UpdaterDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.UpdaterDate;
      date = date.replace("T", " ");
      date = date.substring(0, 19);
      return date;
    } else {
      return "";
    }
  }
  //当前选中
  getTemplateRow(index: any, row: any) {
    //获取选中数据
    this.templateSelection = row;
  }
  //功能库确定
  librarycheck() {
    if (!this.templateSelection) {
      this.$message.error("请先选择一条记录，再确定！");
    } else {
      this.libraryview = false;
    }
  }
  //功能库取消
  libraryclose() {
    this.templateSelection = undefined;
    this.AddaccountForm.JumpLink = "";
    this.libraryview = false;
  }

  //查看文章
  handleView(index: any, row: any) {
    if (row.Link) {
      //window.open(row.UrlLink);
      window.open(
        row.Link,
        "newwin"
      );
    } else {
      this.$message.error("请先拉取公众号文章！");
    }
  }
  formatNature(row: any, column: any) {
    switch (row.Nature) {
      case 0:
        return "临时素材";
        break;
      default:
        return "永久素材";
        break;
    }
  }
  //功能库结束
  //查看图片
  onViewImage(imageUrl: string) {
    if (imageUrl) {
      this.viewImage = true;
      var img_url = imageUrl;
      var img = new Image();
      img.src = img_url;
      this.picture.height = Math.ceil((img.height / img.width) * 570) + "px";
      this.picture.url = imageUrl;
    }
  }
  //上传之前的校验
  async onBeforeUploadImage(file: any) {
    const isIMAGE = file.type === "image/jpeg" || "image/jpg" || "image/png";
    const isLt1M = file.size / 1024 / 1024 < 2;
    if (!isIMAGE) {
      this.$message.error("上传文件只能是图片格式!");
      return;
    }
    if (!isLt1M) {
      this.$message.error("上传文件大小不能超过 2MB!");
      return;
    }
    return isIMAGE && isLt1M;
  }

  //上传图片
  async UploadImage(param: any) {
    let reader = new FileReader();
    // let that = this
    reader.readAsDataURL(param.file);
    //console.log(param);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: "AppReplyImage"
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        //console.log(params);
        var res: any = await httpApi.GetUpload(params);
        // console.log(res);
        if (res.ErrorCode == 0) {
          this.AddaccountForm.UploadImage = res.output[0].value;
        } else {
          this.$message.error("失败：" + res.ErrorMessage);
        }
      }
    };
  }

  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
     var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj:any) => {
      that.GetAppData.Aid=obj.Aid;      
    });
    if (this.AddaccountForm.Type == 0) {
      this.switchType = true;
    } else {
      this.switchType = false;
    }
    if (this.AddaccountForm.Nature == 0) {
      this.switchNature = true;
    } else {
      this.switchNature = false;
    }
    if (this.AddaccountForm.State == 1) {
      this.switchState = true;
    } else {
      this.switchState = false;
    }
    console.log(this.AddaccountForm);
  }
  //保存数据
  async SavaTextData() {
    var _this = this;
    (this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        let AppAccount = this.GetAppData;

        if (AppAccount) {
          this.AddaccountForm.ApplicationId = AppAccount.Aid;
          this.AddaccountForm.TenantId = AppAccount.TenantID;
          if (this.switchType) {
            this.AddaccountForm.Type = 0;
          } else {
            this.AddaccountForm.Type = 1;
          }
          if (this.switchNature) {
            this.AddaccountForm.Nature = 0;
          } else {
            this.AddaccountForm.Nature = 1;
          }
          if (this.switchState) {
            this.AddaccountForm.State = 1;
          } else {
            this.AddaccountForm.State = 0;
          }
          //保存的数据 传参
          if (this.AddaccountForm.ImageId) {
            this.AddaccountForm.ActionName = "UPDATE"; //修改方法
          } else {
            this.AddaccountForm.ActionName = "CREATE"; //新增方法
          }

          let params: any = {
            Input: [
              {
                Name: "AppReplyImageDTO",
                value: this.AddaccountForm
              }
            ]
          };
          var res: any = await httpApi.SaveImgText(params);
          if (res.ErrorCode == 0) {
            this.$message.success("保存成功!");
            //保存成功后传个刷新方法过去
            _this.$emit("refresh");
          } else {
            this.$message.error("保存失败：" + res.ErrorMessage);
          }
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
}
